<template>
  <div @click="handleClick" class="cursor-pointer p-1 mb-1 rounded-lg dark:bg-gray-800 card transition duration-200 ease-in-out">
    <!-- Category Image and Name -->
    <div class="flex items-center">
      <div class="w-16 h-16 mr-4 overflow-hidden rounded-lg bg-gray-100 flex items-center justify-center">
        <img
          v-if="category.image"
          :src="category.image"
          :alt="category.nom || 'Category'"
          class="object-cover w-full h-full"
          loading="lazy"
          decoding="async"
        >
        <span v-else class="text-xs text-gray-400 px-1 text-center">{{ (category.nom || '').slice(0, 2).toUpperCase() }}</span>
      </div>
      <h2 class="text-black text-lg font-bold dark:text-white">{{ category.nom }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryBox',
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('category-clicked', this.category);
    }
  }
};
</script>

<style scoped>
.card {
  min-height: 20px; /* Adjust this value as needed */
}
</style>